import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from './../../../components/LoadingSpinner/LoadingSpinner';
import AlertBox from '../../../components/AlertBox/AlertBox';
import { NameValidator } from '../../../helpers/NameValidator';
import AuthOTPModal from '../../Listing/components/AuthOTPModal';
// import { ZoneList } from '../../../helpers/ZoneList';
import Select from 'react-select';
import { GetCurrentZone } from '../../../helpers/CurrentTimeZone';

import { fetchCountry, fetchRegions, fetchTimeZones, fetchTimeZoneswithCountryCode, fetchTimeZoneswithStateName, } from '../../AddListings';
export class SignupView extends React.Component {
  constructor(props) {
    super(props);
    this.handlechange = this.handlechange.bind(this);
    this.submitHandler = this.submitHandler.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = {
      errClass: '',
      termAndCondition: false
    };
  }

  handleSelect(selected, event) {
    let { signUpData } = this.props.Signup;

    if (event.name === "country_id") {
      // signUpData['timezone'] = '';
      signUpData['state_id'] = '';
    }
    if (event.name === "state_id") {
      // signUpData['timezone'] = '';
    }

    if (event.name === "country_id") {
      this.props.dispatch(fetchRegions(selected.value));
      if (selected.iso) {
        this.props.dispatch(fetchTimeZoneswithCountryCode(selected.iso, this.updateTimezone.bind(this)));
      }
    } else if (event.name === "state_id") {
      this.props.dispatch(fetchTimeZoneswithStateName(selected.label, this.updateTimezoneWithState.bind(this)));
      // signUpData['timezone'] = '';
    }
    console.log('signUpData', signUpData)
    signUpData[event.name] = selected.value;

    this.props.setSignUpData(signUpData);
  }

  // @@ update time zone with state name
  updateTimezoneWithState(selected) {
    let { signUpData } = this.props.Signup;
    console.log('selected_timezone', selected)
    if(selected){
      signUpData['timezone'] = selected;

    }
    this.props.setSignUpData(signUpData);
  }

  // @@ update time zone with country code
  updateTimezone(selected) {
    let { signUpData } = this.props.Signup;
    console.log('selected_timezone', selected)
    signUpData['timezone'] = selected;
    this.props.setSignUpData(signUpData);
  }


  handlechange(event) {
    let { signUpData } = this.props.Signup;
    const name = event.target.name;
    const value = event.target.value;
    if (value === 'select') {
      signUpData[name] = '';
    } else {
      signUpData[name] = value;
    }
    this.props.setSignUpData(signUpData);
  }

  componentDidMount() {
    let body = document.body;
    body.className = 'user_signup';
    this.props.dispatch(fetchTimeZones())
    if (this.props.ListingState.authModal !== 'signup') {
      this.props.setAuthModal('');
    }

    this.props.dispatch(fetchCountry())
    // this.updateCurrentTimeZone()
  }

  // @@ update current time zone if time zone not available
  // updateCurrentTimeZone() {
  //   let { signUpData } = this.props.Signup;
  //   if (!signUpData.timezone) {
  //     let curr_timezone = GetCurrentZone()
  //     signUpData['timezone'] = curr_timezone;
  //     this.props.setSignUpData(signUpData);
  //   }
  // }
  componentWillUnmount() {
    this.props.setSignUpData({
      name: '',
      email: '',
      password: '',
      c_password: '',
    });
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  submitHandler(event) {
    event.preventDefault();
    let specials = /[!@#$%^&*()_+\-=\[\]{};':"`~\\|,.<>\/?]+/;
    let regex = /^([_\-\.0-9a-zA-Z]+)@([_\-\.0-9a-zA-Z]+)\.([a-zA-Z]){2,7}$/;
    let myRegEx = /[^a-z \d]/i;
    let { signUpData } = this.props.Signup;
    if (signUpData.name.length < 3) {
      this.props.setErrSignupMessage({
        message: 'Name must contain 3 characters.',
        color: 'teal',
      });
      this.setState({ errClass: 'name' });
    }
    else if (signUpData.name.length > 32) {
      this.props.setErrSignupMessage({
        message: 'Name should not more than 32 characters.',
        color: 'teal',
      });
      this.setState({ errClass: 'name' });
    } else if (!signUpData.email.length) {
      this.props.setErrSignupMessage({
        message: 'Email field is required.',
        color: 'teal',
      });
      this.setState({ errClass: 'email' });
    } else if (!regex.test(signUpData.email)) {
      this.props.setErrSignupMessage({
        message: 'Enter a valid Email Address.',
        color: 'teal',
      });
      this.setState({ errClass: 'email' });
    } else if (signUpData.password.length < 8) {
      this.props.setErrSignupMessage({
        message: 'Password must contain 8 characters',
        color: 'teal',
      });
      this.setState({ errClass: 'password' });
    } else if (signUpData.password.search(/[a-z]/i) < 0) {
      this.props.setErrSignupMessage({
        message: 'Password must contain at least one letter.',
        color: 'teal',
      });
    } else if (signUpData.password.search(/[0-9]/) < 0) {
      this.props.setErrSignupMessage({
        message: 'Password must contain at least one digit.',
        color: 'teal',
      });
    } else if (
      !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(signUpData.password)
    ) {
      this.props.setErrSignupMessage({
        message: 'Password must contain at least one special character.',
        color: 'teal',
      });
    } else if (signUpData.password !== signUpData.c_password) {
      this.props.setErrSignupMessage({
        message: 'Password and Confirm password should be same',
        color: 'teal',
      });
      this.setState({ errClass: 'password' });
    } else if (signUpData.country_id == undefined || signUpData.country_id == '') {
      this.props.setErrSignupMessage({
        message: 'Please select the country!!',
        color: 'teal',
      });
    } else if (signUpData.state_id == undefined || signUpData.state_id == '') {
      this.props.setErrSignupMessage({
        message: 'Please select the region/state!!',
        color: 'teal',
      });
    }
    else if (signUpData.timezone == '') {
      this.props.setErrSignupMessage({
        message: 'Please select the timezone!!',
        color: 'teal',
      });
    } else if (!this.state.termAndCondition) {
      this.props.setErrSignupMessage({
        message: 'Please select term & conditions.',
        color: 'teal',
      });
    } else {
      this.props.register({ ...signUpData, history: this.props.history });
    }
    setTimeout(() => {
      this.setState({ errClass: '' });
      this.props.setErrSignupMessage({ message: '', color: '' });
    }, 5000);
  }

  render() {
    const { errSignupMessage, signUpSpinnerStatus, signUpData } =
      this.props.Signup;
    let { errClass, termAndCondition } = this.state;
    const { authModal } = this.props.ListingState;
    const { errLoginMessage } = this.props.auth;
    // let ZoneList = this.props.AddListingState.timeZoneList;

    // let country = this.props.AddListingState.country;

    const { regions, country, countryTimeZoneList, timeZoneList, stateTimeZoneList } = this.props.AddListingState;
    // let ZoneList = countryTimeZoneList;
    let ZoneList = [];
    if (signUpData.state_id && signUpData.country_id) {
      ZoneList = stateTimeZoneList.length > 0 ? stateTimeZoneList : (countryTimeZoneList.length > 0) ? countryTimeZoneList : timeZoneList
      if (stateTimeZoneList.length > 0) {
        ZoneList = stateTimeZoneList;
      } else if (countryTimeZoneList.length > 0) {
        ZoneList = countryTimeZoneList;
      } else {
        ZoneList = timeZoneList
      }
    } else {
      ZoneList = []
    }

    console.log("signUpDatasignUpData", signUpData)
    return (
      <Fragment>
        <div className="login_form md:w-1/2 bg-white p-4 text-center">
          <div
            className='login_form md:w-full bg-white p-4 text-center'
          // className={
          //   authModal === 'signup'
          //     ? 'login_form bg-white p-4 text-center'
          //     : 'login_form md:w-1/2 bg-white p-4 text-center'
          // }
          >
            {/* @@ cancel and redirect to home page */}
            {!(window.location.pathname.includes('listing')) &&
              <div style={{ position: 'relative', textAlign: "right", fontWeight: "600", cursor: 'pointer', fontSize: '1.2rem' }}>
                <Link to="/" >
                  <img style={{ position: 'absolute', top: '0', right: '0', height: '20px' }} src='/images/close_blue.svg' />
                </Link>
              </div>}

            {errSignupMessage.message ? (
              <AlertBox
                AlertText={errSignupMessage.message}
                color={errSignupMessage.color}
              />
            ) : null}
            {errLoginMessage.message ? (
              <AlertBox
                AlertText={errLoginMessage.message}
                color={errLoginMessage.color}
              />
            ) : null}
            {authModal === 'OTP' ? (
              <AuthOTPModal
                cancelEvent={() => this.props.setAuthModal('')}
                history={this.props.history}
              />
            ) : null}
            <div className="site__logo w-24 m-auto">
              <Link to="/">
                <img
                  className="w-full"
                  src="images/new-web-logo.png"
                  alt="Site Logo"
                />
                <span>Coacherly</span>
              </Link>
            </div>
            <div className="main_forms">
              <form className="login_form" onSubmit={this.submitHandler}>
                <div className="form_title font-bold">
                  <h3>Sign Up</h3>
                </div>
                <div className="form-item">
                  <label>Name</label>
                  <input
                    className={errClass == 'name' ? 'border-red-500' : ''}
                    type="text"
                    name="name"
                    value={signUpData.name}
                    onChange={this.handlechange}
                  />
                </div>
                <div className="form-item">
                  <label>Email Address</label>
                  <input
                    className={errClass == 'email' ? 'border-red-500' : ''}
                    type="text"
                    name="email"
                    value={signUpData.email}
                    onChange={this.handlechange}
                  />
                </div>
                <div className="form-item">
                  <label>Password</label>
                  <input
                    className={errClass == 'password' ? 'border-red-500' : ''}
                    type="password"
                    name="password"
                    value={signUpData.password}
                    onChange={this.handlechange}
                  />
                </div>
                <div className="form-item">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    name="c_password"
                    value={signUpData.c_password}
                    onChange={this.handlechange}
                  />
                </div>

                <div className="form-item">
                  <label>Country:</label>
                  <Select
                    name={"country_id"}
                    className="new_select"
                    options={country}
                    value={country.filter(
                      (option) => option.value == signUpData.country_id
                    )}
                    onChange={this.handleSelect}
                    searchable={true}
                  />
                </div>
                <div className="form-item">
                  <label>Listing Region/State:</label>
                  <Select
                    name={"state_id"}
                    className="new_select"
                    options={regions}
                    value={regions.filter((option) => {
                      return option.value === signUpData.state_id;
                    })}
                    onChange={this.handleSelect}
                    searchable={true}
                  />
                </div>


                <div className="form-item">
                  <label>Time Zone</label>

                  {/* --------------country code------------ */}
                  {/* <select
                        name="timezone"
                        onChange={this.handlechange}
                        value={signUpData.timezone}
                        className='timezone-select'
                      >
                        <option>Select</option>
                        {ZoneList.map((item,i) => (
                          <option key={i} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select> */}
                  <Select
                    name={'timezone'}
                    className="new_select"
                    options={ZoneList}
                    value={ZoneList.filter((option) => {
                      return option.value === signUpData.timezone;
                    })}
                    onChange={this.handleSelect}
                    searchable={true}
                  />
                  {/* -------------------------------------- */}
                </div>

                <div className="form-actions">
                  <button type="submit">
                    {signUpSpinnerStatus ? <LoadingSpinner /> : 'Submit'}
                  </button>
                </div>
                <div className="form-item form-item--checkbox loginTerms">
                  <input
                    id="terms"
                    type="checkbox"
                    value={termAndCondition}
                    onChange={(e) => this.setState({ termAndCondition: e.target.checked })}
                  />
                  <label htmlFor="terms"><p>We Acknowledge and agree to the <Link to="/privacy-policy">Privacy Policy</Link>, <Link to="/terms-and-conditions">Terms & Conditions</Link> and <Link to="/coach-contract">Coach Contract</Link>.</p></label>
                </div>
                {authModal !== 'signup' ? (
                  <div className="forget_pwd">
                    <p>
                      Already have a account{' '}
                      <Link to="/user/login" className="text_nav_blue" >
                        Login!
                      </Link>
                    </p>
                  </div>
                ) : null}
              </form>
            </div>
          </div>
          {/* {authModal !== 'signup' ? (
            <div className="welcome_note text-white text-center md:mb-8 md:w-1/2 p-6 md:px-8 lg:px-16 md:pb-5">
              <div className="form_text--title">
              </div>
              <div className="login__text">
                <p>
                Coacherly online coaching software was created specifically to help those who suffer from addiction.

Our team has many decades of experiential knowledge in addiction recovery, coaching, counseling, sober living, and treatment. Our mission is to connect your services to those who need them the most. Here are some articles written by experts for you! Please take some time to read and share, thank you!
                </p>
                <p>
                Online Recovery Coaching offers a way to provide support and guidance to those who are struggling with addictions. Our experts have helped many individuals find hope again by providing them with one-on-one care through their own devices, in their safe space. Search our experts, book an appointment and have your session through our amazing new platform.
                </p>
              </div>
              <div className="btn login_text--btn">
                <Link to="/login">Login</Link>
              </div>
            </div>
          ) : null} */}
        </div>
      </Fragment>
    );
  }
}

// SignupView.propTypes = {
//   history: PropTypes.object.isRequired,
//   register: PropTypes.func.isRequired,
//   Signup: PropTypes.object.isRequired,
//   setErrSignupMessage: PropTypes.func.isRequired,
// };

export default SignupView;



// WEBPACK FOOTER //
// ./src/routes/Signup/components/SignupView.js